import { useMemo, useState } from 'react';
import { Box, Text, Flex, Image, useColorModeValue } from '@chakra-ui/react';

import notifyError from 'assets/svg/notify-error.svg';

import Card from 'components/Card/Card';

export default function Errors (props) {
  const bg = useColorModeValue('#f9ddeb80', 'rgba(24, 23, 16, 0.50)');

  return (
    <>
    	<Card 
          bg={bg}
          borderRadius="16px"
          maxW={props.maxW ?? '100%'}
          mt={props.mt ?? 'unset'}
          variant="ghost" 
          padding='16px'
          backdropFilter="blur(15px)" 
          border="1px solid #ED2014"
          mb={{ base: '8px' }}>
          <Flex alignItems="center" gap="10px">
            <Image src={notifyError} h="24px"/>
            <Text maxW={{sm: '100%', md: '70%'}} variant="text-sm">
			  {typeof props.error === 'string' ? `Error: ${props.error}` : 'An unknown error occurred, try changing the fields or refreshing the page'}
            </Text>
          </Flex>
        </Card>
    </>
  );
}